import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FormBuilder } from "components/FormBuilder/FormBuilder";
import AgentAsyncAutocomplete from "./AgentAsyncAutocomplete";
import merchantManagement from "routes/merchantManagement";
import { useWatch } from "react-hook-form";

const PAGE_LOCALE_KEY = "page.merchants.addMerchant.";

const AgentAssignmentSection = ({ formProps, isLoading, defaultAgent, redirectFn }) => {
  const { t } = useTranslation();

  const selectedAgentEmail = useWatch({ control: formProps.control, name: "isoAgentEmail" });

  const parsedDefaultAgent = useMemo(() => {
    if (selectedAgentEmail) return { email: selectedAgentEmail };
    else return defaultAgent;
  }, []);

  const redirectToAddAgentPage = useCallback(() => {
    const path = "/merchant-management/agents/add-agent";
    const redirectPayload = {
      name:
        merchantManagement
          .find((tab) => tab.tabName === "Agents")
          .page.find((page) => page.path === path).name,
      path: path,
    };
    redirectFn("redirectPage", redirectPayload);
  }, [redirectFn]);

  return (
    <FormBuilder.Section
      title={t(`${PAGE_LOCALE_KEY}agentAssignment.title`)}
      titleVariant="h3"
    >
      <FormBuilder.Row itemsPerRow={1}>
        <AgentAsyncAutocomplete
          t={t}
          formProps={formProps}
          defaultAgent={parsedDefaultAgent}
          disabled={isLoading}
          label={t(`${PAGE_LOCALE_KEY}agentAssignment.agent`)}
          placeholder={t(`${PAGE_LOCALE_KEY}agentAssignment.placeholder`)}
          errorMessage={t("general.message.mandatory")}
          redirectToAddAgentPage={redirectToAddAgentPage}
        />
      </FormBuilder.Row>
    </FormBuilder.Section >
  );
};

export default AgentAssignmentSection;
